/**
 * YLI GA4 Video Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track YouTube video engagement using YouTube IFrame API
 * GA4 Events: video_tutorial_play, video_tutorial_complete
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // Track which videos have been tracked to prevent duplicates
  const trackedPlays = new Set();
  const trackedCompletions = new Set();

  // Load YouTube IFrame API if not already loaded
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Initialize tracking when API is ready
  window.onYouTubeIframeAPIReady = function() {
    const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');

    iframes.forEach(function(iframe, index) {
      // Enable API for iframes that don't have it
      const src = iframe.getAttribute('src');
      if (src && !src.includes('enablejsapi=1')) {
        const separator = src.includes('?') ? '&' : '?';
        iframe.setAttribute('src', src + separator + 'enablejsapi=1');
      }

      // Create player instance
      const player = new YT.Player(iframe, {
        events: {
          'onStateChange': function(event) {
            onPlayerStateChange(event, iframe, index);
          }
        }
      });
    });
  };

  // Handle player state changes
  function onPlayerStateChange(event, iframe, videoIndex) {
    const videoUrl = iframe.getAttribute('src') || '';
    const videoId = extractVideoId(videoUrl);
    const videoTitle = iframe.getAttribute('title') || 'Video ' + (videoIndex + 1);

    // Get video duration from player
    const duration = event.target.getDuration ? event.target.getDuration() : 0;
    const currentTime = event.target.getCurrentTime ? event.target.getCurrentTime() : 0;

    // Detect category from page or video title
    const videoCategory = detectCategory(videoTitle);

    // Playing state
    if (event.data === YT.PlayerState.PLAYING) {
      const trackingKey = videoId + '_play';

      if (!trackedPlays.has(trackingKey)) {
        trackedPlays.add(trackingKey);

        if (typeof gtag === 'function') {
          gtag('event', 'video_tutorial_play', {
            'video_title': videoTitle,
            'video_category': videoCategory,
            'video_duration': Math.round(duration)
          });
        }
      }
    }

    // Ended state (90%+ completion)
    if (event.data === YT.PlayerState.ENDED || (currentTime / duration) >= 0.9) {
      const trackingKey = videoId + '_complete';

      if (!trackedCompletions.has(trackingKey)) {
        trackedCompletions.add(trackingKey);

        const completionRate = Math.round((currentTime / duration) * 100);

        if (typeof gtag === 'function') {
          gtag('event', 'video_tutorial_complete', {
            'video_title': videoTitle,
            'completion_rate': completionRate >= 90 ? completionRate : 100
          });
        }
      }
    }
  }

  // Extract video ID from URL
  function extractVideoId(url) {
    const match = url.match(/(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=)([^&?\/]+)/);
    return match ? match[1] : 'unknown';
  }

  // Detect video category from title or page context
  function detectCategory(title) {
    const titleLower = title.toLowerCase();

    if (titleLower.includes('tension')) return 'tension';
    if (titleLower.includes('troubleshoot')) return 'troubleshooting';
    if (titleLower.includes('thread weight')) return 'thread_basics';
    if (titleLower.includes('longarm')) return 'longarm';
    if (titleLower.includes('machine quilt')) return 'machine_quilting';
    if (titleLower.includes('hand quilt')) return 'hand_quilting';
    if (titleLower.includes('applique')) return 'applique';
    if (titleLower.includes('embroidery')) return 'embroidery';

    return 'general';
  }

  // Fallback: If API is already loaded, initialize immediately
  if (window.YT && window.YT.Player) {
    window.onYouTubeIframeAPIReady();
  }

})();
